import { render } from "./NtumaAccounts.vue?vue&type=template&id=64d22f12"
import script from "./NtumaAccounts.vue?vue&type=script&lang=js"
export * from "./NtumaAccounts.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__